import TEXTES_PUBLICS_BASE from './traductions/publics.json' with { type: 'json' };
import { TEXTES_DISTRIBUTION_PUBLICS } from './textes-distribution-publics.js';
import { TEXTES_PROMOTIONS_PUBLICS } from './textes-promotions-publics.js';
import { TEXTES_COMMUNICATION_PUBLICS } from './textes-communication-publics.js';
import { TEXTES_BONS_PUBLICS } from './textes-bons-publics.js';
export const TEXTES_PUBLICS = {
    ...TEXTES_DISTRIBUTION_PUBLICS,
    ...TEXTES_COMMUNICATION_PUBLICS,
    ...TEXTES_BONS_PUBLICS,
    ...TEXTES_PROMOTIONS_PUBLICS,
    ...TEXTES_PUBLICS_BASE,
};
export function textePublic(clef, langue, ...argumentsTexte) {
    const modele = langue === 'fr' ? clef : TEXTES_PUBLICS[clef][langue];
    const valeurs = argumentsTexte[0];
    return modele.replace(/\{([A-Za-z]\w*)\}/gu, (_champ, nom) => {
        const valeur = valeurs?.[nom];
        if (valeur === undefined)
            throw new Error('Paramètre manquant dans un texte public.');
        return String(valeur);
    });
}
/** Traduit uniquement les textes métier connus. Les données éditoriales, noms
 * et diagnostics inconnus restent intacts ; aucun détail de conflit n’est perdu. */
export function traduireTexteConnu(texte, langue) {
    if (langue === 'fr')
        return texte;
    const direct = Object.hasOwn(TEXTES_PUBLICS, texte)
        ? TEXTES_PUBLICS[texte]
        : undefined;
    if (direct)
        return direct[langue];
    for (const modele of MODELES_TEXTES) {
        const valeurs = reconnaitreModele(texte, modele.fragments, modele.parametres);
        if (valeurs) {
            const cible = TEXTES_PUBLICS[modele.clef][langue];
            return cible.replace(/\{([A-Za-z]\w*)\}/gu, (_champ, nom) => valeurs[nom] ?? '');
        }
    }
    return texte;
}
const MODELES_TEXTES = Object.keys(TEXTES_PUBLICS)
    .filter((clef) => clef.includes('{'))
    .map((clef) => {
    const morceaux = clef.split(/\{([A-Za-z]\w*)\}/gu);
    return {
        clef,
        fragments: morceaux.filter((_, i) => i % 2 === 0),
        parametres: morceaux.filter((_, i) => i % 2 === 1),
    };
})
    .sort((a, b) => b.fragments.join('').length - a.fragments.join('').length);
function reconnaitreModele(texte, fragments, parametres) {
    const premier = fragments[0] ?? '';
    if (!texte.startsWith(premier))
        return null;
    let position = premier.length;
    const valeurs = {};
    for (let i = 0; i < parametres.length; i += 1) {
        const nom = parametres[i];
        if (nom === undefined)
            return null;
        const suivant = fragments[i + 1] ?? '';
        const fin = suivant === '' ? texte.length : texte.indexOf(suivant, position);
        if (fin < position)
            return null;
        const valeur = texte.slice(position, fin);
        if (valeurs[nom] !== undefined && valeurs[nom] !== valeur)
            return null;
        valeurs[nom] = valeur;
        position = fin + suivant.length;
    }
    return position === texte.length ? valeurs : null;
}
//# sourceMappingURL=textes-publics.js.map